import React from 'react';
import { Info, AlertCircle, CheckCircle } from 'lucide-react';
import './AccountMessage.scss';
import { useLanguage } from 'hooks/Language/useLanguage';

const AccountMessage = ({
  type = 'info',
  title = 'No Linked account found',
  message = 'You should contact our customer service for further assistance.',
  description = '',
  className = 'message-container',
}) => {
  const { translate } = useLanguage();
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle />;
      case 'warning':
        return <AlertCircle />;
      case 'error':
        return <AlertCircle />;
      default:
        return <Info />;
    }
  };

  return (
    <div className={`${className}`}>
      <div className={`message-card ${type}`}>
        <div className="message-content">
          <div className="message-header">
            <div className="icon">{getIcon()}</div>
            <div className="text-content">
              <h3 className="title">{translate(title)}</h3>
              <p className="main-message">{translate(message)}</p>
              <p className="description">{translate(description)}</p>
            </div>
          </div>

          {/* <div className="message-footer">
            <span className="support-text">Need assistance?</span>
            <button className="support-button">
              Contact Support
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AccountMessage;
